<span class="caregiver-display" [class.navigable]="canNavigate" (click)="goToCaregiverPage()" [innerHTML]="caregiverNameHtml"></span>

